import {
  DailyStatusReportStateTypes,
  DailyStatusReportActionTypes,
} from "./DailyStatusReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DailyStatusReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DailyStatusReportReducer = (
  state: DailyStatusReportStateTypes = INITIAL_STATE,
  action: any
): DailyStatusReportStateTypes => {
  switch (action.type) {
    case DailyStatusReportActionTypes.FETCH_ALL_DAILY_STATUS_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyStatusReportActionTypes.FETCH_ALL_DAILY_STATUS_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyStatusReportActionTypes.FETCH_ALL_DAILY_STATUS_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyStatusReportActionTypes.FETCH_ALL_DAILY_STATUS_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DailyStatusReportActionTypes.FETCH_ONE_DAILY_STATUS_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyStatusReportActionTypes.FETCH_ONE_DAILY_STATUS_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyStatusReportActionTypes.FETCH_ONE_DAILY_STATUS_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyStatusReportActionTypes.FETCH_ONE_DAILY_STATUS_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DailyStatusReportReducer;
